import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconExperiment = ({ color, ...other }) => (
  <SvgIcon viewBox="0 0 12 13" {...other}>
    <path d="M3.5,0A.5.5,0,0,0,3,.5a.5.5,0,0,0,.5.5H4V5.29L.21,11.07A1.23,1.23,0,0,0,1,13H11a1.23,1.23,0,0,0,.81-1.93L8,5.29V1h.5A.5.5,0,0,0,9,.5.5.5,0,0,0,8.5,0Z" />
  </SvgIcon>
);

IconExperiment.propTypes = {
  color: PropTypes.string,
};

IconExperiment.defaultProps = {
  color: '',
};

export default IconExperiment;
